<template>
    <div class="text-filter">
        <el-row type="flex" justify="left">
            <el-col :xs="{span: 24}" :sm="{span: 24}">

                <el-row type="flex" justify="center">
                    <el-col :xs="{span: 1}" :sm="{span: 2}">
                        <div style="height: 1px;"></div>
                    </el-col>

                    <el-col :xs="{span: 22}" :sm="{span: 20}">
                        <el-input   :placeholder="placeholder || 'Search by text'"
                                    v-model="filter"
                                    :clearable="true"
                                    :class="'retro retro-search game-list-filter'" :disabled="isLoading"
                                    @change="onChange({ filter })"
                                    @keyup.enter.native="onChange({ filter })">
                            <i slot="prefix" class="el-input__icon el-icon-loading" v-show="isLoading"></i>
                        </el-input>
                    </el-col>

                    <el-col :xs="{span: 1}" :sm="{span: 2}">
                        <div style="height: 1px;"></div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  name: 'TextFilter',
  components: {},
  props: ['isLoading', 'onChange', 'placeholder'],
  mounted () {},
  data () {
    return {
      filter: ''
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.text-filter {
    .retro-search {
        margin-left: 0px;
        max-width: 400px;
        width: 90%;
    }

    .retro-selection {
        margin-bottom: 1em;

        .el-input__inner {
            border-left-width: 1px;
        }

        .el-tag.el-tag--info {
            color: purple;
            font-size: $font-size-small;
            padding: 1px;
            padding-left: 3px;
            padding-right: 5px;
        }

        .el-tag .el-icon-close {
            margin-left: -6px;
            color: purple;
        }
    }
}
</style>
